export default {
	0: "Male",
	1: "Female",
	2: "Other"
};
